import * as React from 'react';
import styled from 'styled-components/macro';
import {
  EmailShareButton,
  FacebookShareButton,
  RedditShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  RedditIcon,
  TelegramIcon,
  TwitterIcon,
  WhatsappIcon,
} from 'react-share';
import { logEvent } from 'utils/analytics';

const Wrapper = styled.div`
  button {
    margin-right: 8px;
    outline: 0;

    &:last-child {
      margin-right: 0;
    }
  }
`;

export interface ShareButtonsProps {
  url: string;
  title?: string;
  text?: string;
}

function logShareEvent(platform: string) {
  logEvent('share_nft', {
    event_category: 'Social',
    event_label: `Sharing on ${platform}`,
    platform,
  });
}

const ShareButtons: React.FC<ShareButtonsProps> = ({
  url,
  title = '',
  text = '',
}) => {
  return (
    <Wrapper>
      <TwitterShareButton url=" " title={text} beforeOnClick={() => logShareEvent('Twitter')}>
        <TwitterIcon size={32} round />
      </TwitterShareButton>

      <TelegramShareButton url=" " title={text} beforeOnClick={() => logShareEvent('Telegram')}>
        <TelegramIcon size={32} round />
      </TelegramShareButton>

      <WhatsappShareButton
        url=" "
        title={text}
        separator=":: "
        beforeOnClick={() => logShareEvent('Whatsapp')}
      >
        <WhatsappIcon size={32} round />
      </WhatsappShareButton>

      <RedditShareButton
        url=" "
        title={text}
        windowWidth={660}
        windowHeight={460}
        beforeOnClick={() => logShareEvent('Reddit')}
      >
        <RedditIcon size={32} round />
      </RedditShareButton>

      <FacebookShareButton url={url} quote={text} beforeOnClick={() => logShareEvent('Facebook')}>
        <FacebookIcon size={32} round />
      </FacebookShareButton>

      <EmailShareButton
        url=""
        subject={title}
        body={text}
        beforeOnClick={() => logShareEvent('Email')}
      >
        <EmailIcon size={32} round />
      </EmailShareButton>
    </Wrapper>
  );
};

export default ShareButtons;
